<app-main>
  <h1>Incidents affranchis</h1>
  <div
    style="margin-bottom: 16px; display: flex; justify-content: space-between"
  >
    <app-generic-search-label
      [listElements]="listAffranchis"
      [tableConfig]="tableConfig"
      endPoint="incident"
      (queryEmit)="loadAffranchis($event)"
    ></app-generic-search-label>
  </div>
  <app-generic-table
    [config]="tableConfig"
    [rows]="listAffranchis"
    [pageInformations]="pageInformations"
    (pageEmit)="pageEvent($event)"
    [detailsbutton]="true"
    [deletebutton]="true"
    (deleteEmit)="deleteIncidentAffranchi($event)"
    [isClickable]="true"
    [emitClickRow]="emitClickRow"
    (detailsEmit)="openDetails($event)"
  ></app-generic-table>
</app-main>
